import client from "../client/client";

const getDashboard = async () => {
  const id = sessionStorage.getItem("User");
  try {
    const resp = await client.get(`warehouse-api/search/dashboard/${id}`);
    return resp;
  } catch (error) {
    console.error("Error al obtener el dashboard:", error);
    throw error;
  }
};

const dashboardService = {
  getDashboard,
};

export default dashboardService;
